function checkIfApartmentHasError(state) {
  return state.apartment.value ? state.apartment.hasError : false;
}

export const checkIfResidencePageIsValid = (state) =>
  !(
    state.streetAddress.hasError ||
    state.city.hasError ||
    checkIfApartmentHasError(state) ||
    state.stateOrProvince.hasError ||
    state.postalCode.hasError
  );

export const checkIfIncomePageIsValid = (state) => !state.income.hasError;

export const checkIfDateOfBirthIsValid = (state) =>
  !(
    state.dateOfBirth.day.hasError ||
    state.dateOfBirth.year.hasError ||
    state.dateOfBirth.month.hasError ||
    state.dateOfBirth.errorMessage.hasError
  );
export const checkIfNameIsValid = (state) => !(state.firstName.hasError || state.lastName.hasError);
export const checkIfEmailIsValid = (state) => !state.email.hasError;

export const checkIfPersonalInfoIsValid = (state) =>
  checkIfNameIsValid(state) && checkIfDateOfBirthIsValid(state) && checkIfEmailIsValid(state);

export const checkIfPhoneNumberIsValid = (state) => !state.phoneNumber.hasError;

export const checkIfDateIsValid = (state) => {
  if (!(state.dateOfBirth.day.value && state.dateOfBirth.month.value && state.dateOfBirth.year.value)) return false;
  const month = parseInt(state.dateOfBirth.month.value, 10);
  const day = parseInt(state.dateOfBirth.day.value, 10);
  const year = parseInt(state.dateOfBirth.year.value, 10);
  const date = new Date(`${month}/${day}/${year}`);
  return !isNaN(date.getDate()) && date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year;
};

export const calculateAge = (state) => {
  if (!(state.dateOfBirth.day.value && state.dateOfBirth.month.value && state.dateOfBirth.year.value)) return -1;
  const month = parseInt(state.dateOfBirth.month.value, 10);
  const day = parseInt(state.dateOfBirth.day.value, 10);
  const year = parseInt(state.dateOfBirth.year.value, 10);
  const inputDate = new Date(year, month - 1, day);
  const today = new Date();
  const birthDate = new Date(inputDate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const months = today.getMonth() - birthDate.getMonth();
  if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const checkIfAgeIsMoreThan100 = (state) => {
  const age = calculateAge(state);
  return age >= 100;
};

export const checkIfAgeIsBelowEighteen = (state) => {
  const age = calculateAge(state);
  return age <= 18;
};

export const resetDayMonthYearErrors = (state) => {
  state.dateOfBirth.year.hasError = false;
  state.dateOfBirth.year.errorMessage = '';
  state.dateOfBirth.month.hasError = false;
  state.dateOfBirth.month.errorMessage = '';
  state.dateOfBirth.day.hasError = false;
  state.dateOfBirth.day.errorMessage = '';
};

export const resetDateError = (state) => {
  state.dateOfBirth.errorMessage.hasError = false;
  state.dateOfBirth.errorMessage.value = '';
};

export const checkIfReviewPageIsValid = (state) => checkIfFormIsValid(state) && state.acceptedTermsAndConditions.value;

export const checkIfFormIsValid = (state) =>
  checkIfDateOfBirthIsValid(state) &&
  checkIfResidencePageIsValid(state) &&
  checkIfPersonalInfoIsValid(state) &&
  !state.income.hasError &&
  !state.email.hasError;
